<template>
  <footer class="AtlasFooter">
    Powered by the
    <a href="http://nationalequityatlas.org/">National Equity Atlas</a>
  </footer>
</template>

<script>
export default {
  name: 'atlas-footer',
};
</script>

<style lang="scss">
.AtlasFooter {
  height: $footer-height;
  padding: 5px $gutter 4px;
  background: color(bg);
  color: color(disabled);
  font-size: 13px;
  line-height: 16px;
}
</style>
